import styles from "./totalExecutionTime.module.scss";
import { useMemo } from "react";
import { TransformExecuteResponse } from "../../types/clientTypes";
import { useTranslation } from "react-i18next";

type TotalExecutionTimeProps = {
  maximumExecutionTimeout: number;
  executeResponses: Array<TransformExecuteResponse>
}

export const TotalExecutionTime = ({ maximumExecutionTimeout, executeResponses }: TotalExecutionTimeProps) => {
  const { t } = useTranslation();

  const totalExecutionTime = useMemo(() => {
    let result = 0;
    executeResponses.forEach(item => result += item.time);
    return result;
  }, [executeResponses]);

  const totalExecutionTimeStyle = useMemo(() => {
    let result = styles.result;
    if (totalExecutionTime < maximumExecutionTimeout * 1000) {
      result += ` ${styles.passed}`;
    } else {
      result += ` ${styles.error}`;
    }

    return result;
  }, [totalExecutionTime, maximumExecutionTimeout]);

  return (
      <>
        <div className={styles.total}>
          {t("scenario.totalExecutionTime")}
          <div className={`${styles.totalResult} ${totalExecutionTimeStyle}`}>
            {totalExecutionTime}{t("common.ms")}
          </div>
        </div>
      </>
  );
}
